
/* eslint-disable */
// @ts-nocheck
import {Options, Vue} from 'vue-class-component';
import {sendMessageApp, logNative} from '@/utils/utils';

// 脚本定时器
let scriptTimer = null;

// 页面1 - spine1
let pageOneSpine1 = null;
// 页面1 - spine2
let pageOneSpine2 = null;
// 页面2 - spine1
let pageTwoSpine1 = null;
// 页面2 - spine2
let pageTwoSpine2 = null;
// 页面3 - spine1
let pageThreeSpine1 = null;
// 页面3 - spine2
let pageThreeSpine2 = null;
// 页面4 - spine1
let pageFourSpine1 = null;
// 页面4 - spine2
let pageFourSpine2 = null;

@Options({
    props: {
        picbookData: {
            type: Array,
            default() {
                return [];
            }
        },
        routeName: {
            type: String,
            default() {
                return 'picbook';
            }
        },
    },
    async created() {
        console.log('进入绘本组件，传入的数据 this.picbookData', this.picbookData);
        // 注册端能力
        await this.registerFunc();
    },
    mounted() {
        // 绑定监听用户左滑右滑事件
        this.handleAddSlideEvent();
    },
    beforeUnmount() {
        // 清空所有定时器
        this.clearAllTimer();
    },
})
export default class picbook extends Vue {
    // 当前绘本的页数
    currentPicbookPageNo = 0;

    // 绘本总页数
    picbookTotalPages = 4;

    // 是否正在播放翻页动效
    isFlipingPage = false;

    // 音频节点
    audioEl = null;

    // 真正使用的页面音频数据
    picbookDataReal = [];

    // 用户语音1
    userAudio1 = '';

    // 用户语音2
    userAudio2 = '';

    // 用户语音3
    userAudio3 = '';

    // 用户语音4
    userAudio4 = '';

    // 是否正在播放音频
    isPlayingAudio = false;

    // 页面是否正在暂停
    isPagePaused = false;

    // 标识位，整个绘本是否播放完毕
    // isPicbookPlayFinished = false;

    // 是否展示播放按钮遮罩
    isShowPlayBtnOverlay = false;

    // 是否隐藏第一页的spine
    isHideFirstSpine = false;

    // spine 是否初始化完成
    isSpineInited = false;

    // 清空所有定时器
    clearAllTimer() {
        scriptTimer && clearTimeout(scriptTimer);
        scriptTimer = null;
    }

    // 播放语音
    playAudio(url) {
        console.log(' ------ playAudio ------', url);
        // 播放语音
        return new Promise((resolve, reject) => {
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    logNative(JSON.stringify({
                        content: 'playAudio onabort',
                        audioUrl: url,
                    }));
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    logNative(JSON.stringify({
                        content: 'playAudio onwaiting',
                        audioUrl: url,
                    }));
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                // 语音播放完毕
                this.isPlayingAudio = false;
                resolve();
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                this.isPlayingAudio = false;
                // resolve();
            };
            this.audioEl.onerror = err => {
                logNative(JSON.stringify({
                    content: 'playAudio onerror',
                    audioUrl: url,
                    error: this.audioEl.error?.message
                }));
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                // 语音播放完毕
                this.isPlayingAudio = false;
                resolve(err);
            };
            this.audioEl.play();
            // 正在播放语音
            this.isPlayingAudio = true;
        });
    }

    // 初始化所有的 spine 并在初始化完成之后播放第一页脚本
    async initAllSpine() {
        console.log('进入initAllSpine');
        const url = window.location.href;
        const routeName = this.routeName;
        const index = url.indexOf(routeName);
        console.log('url.slice(0, index)', url.slice(0, index));

        // 1
        const pageOneSpine1Path = `${url.slice(0, index)}static/spine/demo/spine1/大勺.json`;
        console.log('pageOneSpine1Path', pageOneSpine1Path);
        await window.PIXI.Assets.load(pageOneSpine1Path).then(resources => {
            console.log('spine 资源加载成功  111', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-dashao'),
                backgroundAlpha: 0,
                width: 375,
                height: 500,
            });
            // 设置并开始播放呼吸态
            pageOneSpine1 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageOneSpine1, 'pageOneSpine1');
            app.stage.addChild(pageOneSpine1);
            pageOneSpine1.x = 187.5;
            pageOneSpine1.y = 250;
            pageOneSpine1.state.setAnimation(0, 'animation1', true);
        });

        // 2
        const pageOneSpine2Path = `${url.slice(0, index)}static/spine/demo/spine2/konlong.json`;
        await window.PIXI.Assets.load(pageOneSpine2Path).then(resources => {
            console.log('spine 资源加载成功  222', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-konlong'),
                backgroundAlpha: 0,
                width: 1000,
                height: 1000,
            });
            // 设置动画
            pageOneSpine2 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageOneSpine2, 'pageOneSpine2');
            app.stage.addChild(pageOneSpine2);
            pageOneSpine2.x = 500;
            pageOneSpine2.y = 500;
            pageOneSpine2.state.setAnimation(0, 'animation1', true);
        });

        // 3
        const pageTwoSpine1Path = `${url.slice(0, index)}static/spine/demo/spine3/tuzi.json`;
        await window.PIXI.Assets.load(pageTwoSpine1Path).then(resources => {
            console.log('spine 资源加载成功  333', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-dashao2'),
                backgroundAlpha: 0,
                width: 375,
                height: 500,
            });
            // 设置并开始播放呼吸态
            pageTwoSpine1 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageTwoSpine1, 'pageTwoSpine1');
            app.stage.addChild(pageTwoSpine1);
            pageTwoSpine1.x = 187.5;
            pageTwoSpine1.y = 250;
            pageTwoSpine1.state.setAnimation(0, 'animation1', true);
        });

        // 4
        const pageTwoSpine2Path = `${url.slice(0, index)}static/spine/demo/spine4/SRCH.json`;
        await window.PIXI.Assets.load(pageTwoSpine2Path).then(resources => {
            console.log('spine 资源加载成功  444', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-konlong2'),
                backgroundAlpha: 0,
                width: 1000,
                height: 1000,
            });
            // 设置动画
            pageTwoSpine2 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageTwoSpine2, 'pageTwoSpine2');
            app.stage.addChild(pageTwoSpine2);
            pageTwoSpine2.x = 500;
            pageTwoSpine2.y = 500;
            pageTwoSpine2.state.setAnimation(0, 'animation1', true);
        });

        // 5
        const pageThreeSpine1Path = `${url.slice(0, index)}static/spine/demo/spine5/xyx_diusanlasi_maodou.json`;
        await window.PIXI.Assets.load(pageThreeSpine1Path).then(resources => {
            console.log('spine 资源加载成功  555', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-dashao3'),
                backgroundAlpha: 0,
                width: 375,
                height: 500,
            });
            // 设置并开始播放呼吸态
            pageThreeSpine1 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageThreeSpine1, 'pageThreeSpine1');
            app.stage.addChild(pageThreeSpine1);
            pageThreeSpine1.x = 187.5;
            pageThreeSpine1.y = 250;
            pageThreeSpine1.state.setAnimation(0, 'animation1', true);
        });

        // 6
        const pageThreeSpine2Path = `${url.slice(0, index)}static/spine/demo/spine6/erwu.json`;
        await window.PIXI.Assets.load(pageThreeSpine2Path).then(resources => {
            console.log('spine 资源加载成功  666', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-konlong3'),
                backgroundAlpha: 0,
                width: 1000,
                height: 1000,
            });
            // 设置动画
            pageThreeSpine2 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageThreeSpine2, 'pageThreeSpine2');
            app.stage.addChild(pageThreeSpine2);
            pageThreeSpine2.x = 500;
            pageThreeSpine2.y = 500;
            pageThreeSpine2.state.setAnimation(0, 'animation', true);
        });

        // 7
        const pageFourSpine1Path = `${url.slice(0, index)}static/spine/demo/spine7/qianduoduo.json`;
        await window.PIXI.Assets.load(pageFourSpine1Path).then(resources => {
            console.log('spine 资源加载成功  777', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-dashao4'),
                backgroundAlpha: 0,
                width: 600,
                height: 800,
            });
            // 设置并开始播放呼吸态
            pageFourSpine1 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageFourSpine1, 'pageFourSpine1');
            app.stage.addChild(pageFourSpine1);
            pageFourSpine1.x = 300;
            pageFourSpine1.y = 400;
            pageFourSpine1.state.setAnimation(0, 'animation', true);
        });

        // 8
        const pageFourSpine2Path = `${url.slice(0, index)}static/spine/demo/spine8/haochilanduo.json`;
        await window.PIXI.Assets.load(pageFourSpine2Path).then(resources => {
            console.log('spine 资源加载成功  888', resources);
            const app = new window.PIXI.Application({
                view: document.querySelector('#spine-konlong4'),
                backgroundAlpha: 0,
                width: 1000,
                height: 1000,
            });
            // 设置动画
            pageFourSpine2 = new window.PIXI.spine.Spine(resources.spineData);
            console.log(pageFourSpine2, 'pageFourSpine2');
            app.stage.addChild(pageFourSpine2);
            pageFourSpine2.x = 500;
            pageFourSpine2.y = 500;
            pageFourSpine2.state.setAnimation(0, 'animation1', true);
            // spine 初始化完毕
            this.isSpineInited = true;
            // 展示第一页的 spine
            this.isHideFirstSpine = false;
            // 页码置为第一页
            this.currentPicbookPageNo = 0;
            // 标识位，整个绘本是否播放完毕
            // this.isPicbookPlayFinished = false;
            // 所有 spine 资源加载完毕之后，开始播放第一页脚本
            this.handlePlayScriptPageOne();
        });
    }

    // 点击播放按钮
    handleClickPlayBtn() {
        console.log('点击播放按钮');
        this.isShowPlayBtnOverlay = false;
        // 如果初始化 spine 了，则直接播放
        if (this.isSpineInited) {
            // 展示第一页的 spine
            this.isHideFirstSpine = false;
            // 页码置为第一页
            this.currentPicbookPageNo = 0;
            // 所有 spine 资源加载完毕之后，开始播放第一页脚本
            this.handlePlayScriptPageOne();
        }
        // 如果没有初始化 spine，则初始化 spine
        else {
            // 初始化所有的 spine 并在初始化完成之后播放第一页脚本
            this.initAllSpine();
        }
    }

    // ———————————————————————— 页面1 start ————————————————————————
    // 播放第一页脚本
    handlePlayScriptPageOne() {
        if (this.isPagePaused) {
            console.log('绘本正在暂停中，不进行脚本播放');
            return false;
        }
        // 播放大勺动效并播放语音
        this.playSpineDashao();
        // 播放恐龙动效并播放语音
        this.playSpineKonlong();
    }

    // 初始化页面1
    initPageOne() {
        // 动效恢复呼吸态
        pageOneSpine1.state.setAnimation(0, 'animation1', true);
        pageOneSpine2.state.setAnimation(0, 'animation1', true);
    }

    // 播放大勺动效并播放语音
    playSpineDashao() {
        console.log('playSpineDashao');
        pageOneSpine1.state.setAnimation(0, 'animation1', true);
        // 清空所有定时器
        this.clearAllTimer();
        // 播放内置语音并播放抬手动作
        scriptTimer = setTimeout(() => {
            // 播放页面1 - 语音1
            this.playAudio('https://p.gsxcdn.com/2189414782_cbn389lf.mp3')
                .then(() => {
                    console.log('音频播放完毕，页面1 - 语音1');
                    // 播放完毕翻页
                    this.handleSlideToLeft(500);
                    // 若有用户语音，则播放页面1 - 语音2
                    // if (this.userAudio1) {
                    //     // 音频播放完毕，播放动效2的抬手动作
                    //     pageOneSpine2.state.setAnimation(0, 'animation2', true);
                    //     this.playAudio(this.userAudio1)
                    //     .then(() => {
                    //         console.log('音频播放完毕，页面1 - 语音2');
                    //         // 播放完毕翻页
                    //         this.handleSlideToLeft(500);
                    //     });
                    // }
                    // // 若没有用户语音，则直接翻页
                    // else {
                    //     console.log('页面1 - 语音2不存在，直接翻页');
                    //     // 播放完毕翻页
                    //     this.handleSlideToLeft(500);
                    // }
                });
            // 播放抬手动作
            pageOneSpine1.state.setAnimation(0, 'animation4', true);
        }, 1888);
    }

    // 播放恐龙动效并播放语音
    playSpineKonlong() {
        console.log('playSpineKonlong');
        pageOneSpine2.state.setAnimation(0, 'animation1', true);
    }
    // ———————————————————————— 页面1 end ————————————————————————

    // ———————————————————————— 页面2 start ————————————————————————
    // 播放第二页脚本
    handlePlayScriptPageTwo() {
        if (this.isPagePaused) {
            console.log('绘本正在暂停中，不进行脚本播放');
            return false;
        }
        // 播放大勺动效并播放语音
        this.playSpineDashao2();
        // 播放恐龙动效并播放语音
        this.playSpineKonlong2();
    }

    // 初始化页面2
    initPageTwo() {
        // 动效恢复呼吸态
        pageTwoSpine1.state.setAnimation(0, 'animation1', true);
        pageTwoSpine2.state.setAnimation(0, 'animation1', true);
    }

    // 播放大勺动效并播放语音
    playSpineDashao2() {
        console.log('playSpineDasha2');
        // 清空所有定时器
        this.clearAllTimer();
        // 播放内置语音并播放抬手动作
        scriptTimer = setTimeout(() => {
            // 播放页面2 - 语音1
            this.playAudio('https://p.gsxcdn.com/2239473174_0cdbrcnb.mp3')
                .then(() => {
                    console.log('音频播放完毕，页面2 - 语音1');
                    // 若有用户语音，则播放页面2 - 语音2
                    if (this.userAudio2) {
                        // 音频播放完毕，播放动效2的抬手动作
                        pageTwoSpine2.state.setAnimation(0, 'animation2', true);
                        this.playAudio(this.userAudio2)
                            .then(() => {
                                console.log('音频播放完毕，页面2 - 语音2');
                                // 播放完毕翻页
                                this.handleSlideToLeft(500);
                            });
                    }
                    // 若没有用户语音，则直接翻页
                    else {
                        console.log('页面2 - 语音2不存在，直接翻页');
                        // 播放完毕翻页
                        this.handleSlideToLeft(500);
                    }

                });
            // 播放抬手动作
            pageTwoSpine1.state.setAnimation(0, 'animation2', true);
        }, 1888);
    }

    // 播放恐龙动效并播放语音
    playSpineKonlong2() {
        console.log('playSpineKonlong2');
        pageTwoSpine2.state.setAnimation(0, 'animation1', true);
    }
    // ———————————————————————— 页面2 end ————————————————————————

    // ———————————————————————— 页面3 start ————————————————————————
    // 播放第三页脚本
    handlePlayScriptPageThree() {
        if (this.isPagePaused) {
            console.log('绘本正在暂停中，不进行脚本播放');
            return false;
        }
        // 播放大勺动效并播放语音
        this.playSpineDashao3();
        // 播放恐龙动效并播放语音
        this.playSpineKonlong3();
    }

    // 初始化页面3
    initPageThree() {
        // 动效恢复呼吸态
        pageThreeSpine1.state.setAnimation(0, 'animation1', true);
        pageThreeSpine2.state.setAnimation(0, 'animation', true);
    }

    // 播放大勺动效并播放语音
    playSpineDashao3() {
        console.log('playSpineDashao3');
        // 清空所有定时器
        this.clearAllTimer();
        // 播放内置语音并播放抬手动作
        scriptTimer = setTimeout(() => {
            // 播放页面3 - 语音1
            this.playAudio('https://p.gsxcdn.com/2238735375_j27qegss.mp3')
                .then(() => {
                    console.log('音频播放完毕，页面3 - 语音1');
                    // 若有用户语音，则播放页面3 - 语音2
                    if (this.userAudio3) {
                        // 音频播放完毕，播放动效2的抬手动作
                        pageThreeSpine2.state.setAnimation(0, 'animation2', true);
                        // 播放页面3 - 语音2
                        this.playAudio(this.userAudio3)
                            .then(() => {
                                console.log('音频播放完毕，页面3 - 语音2');
                                // 播放完毕翻页
                                this.handleSlideToLeft(500);
                            });
                    }
                    // 若没有用户语音，则直接翻页
                    else {
                        console.log('页面3 - 语音2不存在，直接翻页');
                        // 播放完毕翻页
                        this.handleSlideToLeft(500);
                    }
                });
            // 播放抬手动作
            pageThreeSpine1.state.setAnimation(0, 'animation3', true);
        }, 1888);
    }

    // 播放恐龙动效并播放语音
    playSpineKonlong3() {
        console.log('playSpineKonlong3');
        pageThreeSpine2.state.setAnimation(0, 'animation', true);
    }
    // ———————————————————————— 页面3 end ————————————————————————

    // ———————————————————————— 页面4 start ————————————————————————
    // 播放第四页脚本
    handlePlayScriptPageFour() {
        if (this.isPagePaused) {
            console.log('绘本正在暂停中，不进行脚本播放');
            return false;
        }
        // 播放大勺动效并播放语音
        this.playSpineDashao4();
        // 播放恐龙动效并播放语音
        this.playSpineKonlong4();
    }

    // 初始化页面4
    initPageFour() {
        // 动效恢复呼吸态
        pageFourSpine1.state.setAnimation(0, 'animation', true);
        pageFourSpine2.state.setAnimation(0, 'animation1', true);
    }

    // 播放大勺动效并播放语音
    playSpineDashao4() {
        console.log('playSpineDashao4');
        // 清空所有定时器
        this.clearAllTimer();
        // 播放内置语音并播放抬手动作
        scriptTimer = setTimeout(() => {
            // 播放页面4 - 语音1
            this.playAudio('https://p.gsxcdn.com/2244786584_nhqhk4ew.mp3')
                .then(() => {
                    console.log('音频播放完毕，页面4 - 语音1');
                    // 若有用户语音，则播放页面4 - 语音2
                    if (this.userAudio4) {
                        // 音频播放完毕，播放动效2的抬手动作
                        pageFourSpine2.state.setAnimation(0, 'animation2', true);
                        // 播放页面4 - 语音2
                        this.playAudio(this.userAudio4)
                            .then(() => {
                                console.log('音频播放完毕，页面4 - 语音2');
                                // 标识位，整个绘本播放完毕了
                                // this.isPicbookPlayFinished = true;
                                // 播放完毕翻页
                                this.handleSlideToLeft(500);
                            });
                    }
                    // 若没有用户语音，则直接翻页
                    else {
                        console.log('页面4 - 语音2不存在，直接翻页');
                        // 标识位，整个绘本播放完毕了
                        // this.isPicbookPlayFinished = true;
                        // 播放完毕翻页
                        this.handleSlideToLeft(500);
                    }
                });
            // 播放抬手动作
            pageFourSpine1.state.setAnimation(0, 'animation2', true);
        }, 1888);
    }

    // 播放恐龙动效并播放语音
    playSpineKonlong4() {
        console.log('playSpineKonlong4');
        pageFourSpine2.state.setAnimation(0, 'animation1', true);
    }
    // ———————————————————————— 页面4 end ————————————————————————

    // 绑定监听用户左滑右滑事件
    handleAddSlideEvent() {
        // 记录开始触摸的位置
        let startX;
        // 记录结束触摸的位置
        let endX;
        const containerNode = document.querySelector('#picbookContainer');
        // 监听 touchstart 事件
        containerNode.addEventListener('touchstart', (e) => {
            console.log('touchstart');
            startX = e.touches[0].clientX;
        });

        // 监听 touchend 事件
        containerNode.addEventListener('touchend', (e) => {
            console.log('touchend');
            if (this.isPagePaused || this.isShowPlayBtnOverlay) {
                console.log('绘本正在暂停中/未播放，不能手动滑动');
                return false;
            }
            endX = e.changedTouches[0].clientX;
            // 根据触摸开始和结束的位置，判断用户是左滑还是右滑
            if (endX - startX > 18) {
                console.log('用户向右滑');
                // 处理向右滑
                this.handleSlideToRight();
            } else if (startX - endX > 18) {
                console.log('用户向左滑');
                // 处理向左滑
                this.handleSlideToLeft(0);
            }
        });
    }

    // 处理向左滑，左滑为向右翻
    handleSlideToLeft(timeout) {
        if (this.isFlipingPage) {
            console.log('正在播放翻页动效，不处理');
            return false;
        }
        if (this.currentPicbookPageNo >= this.picbookTotalPages - 1) {
            // 已经滑到最后一页了，如果是绘本结果页，则返回到第一页开始循环播放
            if (this.routeName === 'picbook') {
                console.log('已经滑到最后一页了，如果是绘本结果页，则返回到第一页开始循环播放');
                this.currentPicbookPageNo = 0;
                this.handlePlayScriptPageOne();
            }
            // 已经滑到最后一页了，如果是学习报告页，则返回到第一页并暂停
            else {
                this.currentPicbookPageNo = 0;
                this.isShowPlayBtnOverlay = true;
                this.isHideFirstSpine = true;
                // 暂停所有音频
                this.audioEl && this.audioEl.pause();
                this.audioEl = null;
            }
            return false;
        }
        // 正在播放翻页动效
        this.isFlipingPage = true;
        setTimeout(() => {
            const picbookPages = document.getElementsByClassName('picbook-bg');
            picbookPages[this.currentPicbookPageNo].classList.add('flipPage-animation-left');
            picbookPages[this.currentPicbookPageNo + 1].classList.add('picbook-bg-low-index');
            // 提前页码变更
            const originalPicbookPageNo = this.currentPicbookPageNo;
            this.audioEl && this.audioEl.pause();
            this.audioEl = null;
            setTimeout(() => {
                this.isFlipingPage = false;
                picbookPages[originalPicbookPageNo].classList.remove('flipPage-animation-left');
                picbookPages[originalPicbookPageNo + 1].classList.remove('picbook-bg-low-index');
                this.currentPicbookPageNo = this.currentPicbookPageNo + 1;
                this.initPageOne();
                this.initPageTwo();
                this.initPageThree();
                this.initPageFour();
                switch (this.currentPicbookPageNo) {
                    case 1:
                        this.handlePlayScriptPageTwo();
                        break;
                    case 2:
                        this.handlePlayScriptPageThree();
                        break;
                    case 3:
                        this.handlePlayScriptPageFour();
                        break;
                }
            }, 500);
        }, timeout);
    }

    // 处理向右滑，右滑为向左翻
    handleSlideToRight() {
        if (this.isFlipingPage) {
            console.log('正在播放翻页动效，不处理');
            return false;
        }
        if (this.currentPicbookPageNo <= 0) {
            console.log('已经滑到第一页了');
            return false;
        }
        // 标识位，整个绘本是否播放完毕
        // this.isPicbookPlayFinished = false;
        // 正在播放翻页动效
        this.isFlipingPage = true;
        const picbookPages = document.getElementsByClassName('picbook-bg');
        console.log('picbookPages', picbookPages);
        picbookPages[this.currentPicbookPageNo].classList.add('flipPage-animation-right');
        picbookPages[this.currentPicbookPageNo - 1].classList.add('picbook-bg-low-index');
        // 提前页码变更
        const originalPicbookPageNo = this.currentPicbookPageNo;
        this.audioEl && this.audioEl.pause();
        this.audioEl = null;
        setTimeout(() => {
            this.isFlipingPage = false;
            picbookPages[originalPicbookPageNo].classList.remove('flipPage-animation-right');
            picbookPages[originalPicbookPageNo - 1].classList.remove('picbook-bg-low-index');
            this.currentPicbookPageNo = this.currentPicbookPageNo - 1;
            this.initPageOne();
            this.initPageTwo();
            this.initPageThree();
            this.initPageFour();
            switch (this.currentPicbookPageNo) {
                case 0:
                    this.handlePlayScriptPageOne();
                    break;
                case 1:
                    this.handlePlayScriptPageTwo();
                    break;
                case 2:
                    this.handlePlayScriptPageThree();
                    break;
            }
        }, 500);
    }

    // 注册 js 能力给端上调用
    async registerFunc() {
        console.log('进入registerFunc方法');
        if (this.routeName !== 'studyReport') {
            /**
             * 如果是学习报告加载的绘本组件就不需要单独加appDisplayState方法了，学习报告统一处理过了
             */
            // 注册 js 能力 —— 前后台切换
            window.callbackMap.appDisplayState = state => {
                console.log('appDisplayState', state);
                if (!state) {
                    return;
                }
                // state '1'：页面进入前台
                if (String(state) === '1') {
                    console.log('appDisplayState 进入前台');
                }
                // state '2'：页面进入后台
                else if (String(state)  === '2') {
                    console.log('appDisplayState 进入后台');
                }
            };
        }
        // 注册 js 能力 —— 客户端给动态绘本H5页传入绘本数据(或刷新绘本数据)
        window.callbackMap.setPicbookData = picbookDataStr => {
            console.log('setPicbookData', picbookDataStr);
            if (!picbookDataStr) {
                return;
            }
            // 重置页面状态，页面已经恢复
            this.isPagePaused = false;
            this.isPlayingAudio = false;
            // 解析客户端传入的数据
            const picbookDataObj = JSON.parse(picbookDataStr);
            console.log('setPicbookData回调数据', picbookDataObj);
            this.picbookDataReal = picbookDataObj.picbookData;
            // this.userAudio1 = this.picbookDataReal[0] || '';
            this.userAudio2 = this.picbookDataReal[0] || '';
            this.userAudio3 = this.picbookDataReal[1] || '';
            this.userAudio4 = this.picbookDataReal[2] || '';
            // 如果是客户端结果页，则自动播放
            if (this.routeName === 'picbook') {
                // 如果初始化 spine 了，则直接播放
                if (this.isSpineInited) {
                    // 展示第一页的 spine
                    this.isHideFirstSpine = false;
                    // 页码置为第一页
                    this.currentPicbookPageNo = 0;
                    // 所有 spine 资源加载完毕之后，开始播放第一页脚本
                    this.handlePlayScriptPageOne();
                }
                else {
                    // 初始化所有的 spine 并在初始化完成之后播放第一页脚本
                    this.initAllSpine();
                }

            }
            else {
                // 如果是学习报告页/结营报告页，则展示播放按钮遮罩
                this.isShowPlayBtnOverlay = true;
            }
        };

        // 注册 js 能力 —— 操作(暂停/恢复)动态绘本H5页
        window.callbackMap.handlePicbookH5 = typeJsonStr => {
            console.log('handlePicbookH5', typeJsonStr);
            if (!typeJsonStr) {
                return;
            }
            const typeJsonObj = JSON.parse(typeJsonStr);
            if (typeJsonObj.type === 'pause') {
                console.log('暂停H5动态绘本');
                // 页面正在暂停
                this.isPagePaused = true;
                // 如果正在播放语音，则暂停
                if (this.isPlayingAudio) {
                    this.audioEl && this.audioEl.pause();
                }
                // 如果没有在播放语音，则清空所有定时器
                else {
                    // 清空所有定时器
                    this.clearAllTimer();
                }
            }
            else if (typeJsonObj.type === 'resume') {
                console.log('恢复H5动态绘本看看this.isPlayingAudio', this.isPlayingAudio);
                // 页面没有暂停了，页面已经恢复
                this.isPagePaused = false;
                // 如果原来正在播放语音，则继续播放该语音
                if (this.isPlayingAudio) {
                    this.audioEl && this.audioEl.play();
                }
                // 如果原来没有在播放语音，则直接开始播放当前页
                else {
                    // if (this.isPicbookPlayFinished) {
                    //     console.log('整个绘本已经播放完毕，无需重播');
                    //     return false;
                    // }
                    this.initPageOne();
                    this.initPageTwo();
                    this.initPageThree();
                    this.initPageFour();
                    switch (this.currentPicbookPageNo) {
                        case 0:
                            this.handlePlayScriptPageOne();
                            break;
                        case 1:
                            this.handlePlayScriptPageTwo();
                            break;
                        case 2:
                            this.handlePlayScriptPageThree();
                            break;
                        case 3:
                            this.handlePlayScriptPageFour();
                            break;
                    }
                }
            }

        };
        // 如果是从学习报告过来的，自己调用下 js 能力 —— 客户端给动态绘本H5页传入绘本数据(或刷新绘本数据)
        if (this.routeName === 'studyReport') {
            window.callbackMap.setPicbookData(JSON.stringify({
                picbookData: this.picbookData
            }));
        } else {
            // 调用端能力-加载完成 loadFinish，通知客户端去调用 setPicbookData 方法
            setTimeout(() => {
                sendMessageApp('loadFinish');
                // mock，待删
                // setTimeout(() => {
                //     window.callbackMap.setPicbookData(JSON.stringify({
                //         picbookData: [
                //             'https://p.gsxcdn.com/2239473166_8p7jhvk1.mp3',
                //             'https://p.gsxcdn.com/2244760547_rv4ihiiq.mp3',
                //             'https://p.gsxcdn.com/2244760545_h8khx0di.mp3',
                //             // '',
                //             // '',
                //             // '',
                //         ]
                //     }));
                //     // setTimeout(() => {
                //     //     window.callbackMap.handlePicbookH5(JSON.stringify({
                //     //         type: 'pause',
                //     //     }));
                //     //     setTimeout(() => {
                //     //         window.callbackMap.handlePicbookH5(JSON.stringify({
                //     //             type: 'resume',
                //     //         }));
                //     //     }, 3000);
                //     // }, 1500);
                // }, 1000);
            }, 10);
        }
    }
}
